import React from 'react';
import { Box } from '..';

export default function Spacer({ style }) {
  return <Box style={[{ flexGrow: 1 }, style]} />;
}
